import { parse, format } from 'date-fns';
import {es} from 'date-fns/locale';

const convertDate = (dateString,formato = "EEEE dd/MM/yyyy") => {
  // Primero, parseamos la fecha desde el formato original
  // console.log(dateString);
  const parsedDate = parse(dateString, 'dd/MM/yyyy', new Date(), { locale: es });

  // Luego, formateamos la fecha al nuevo formato deseado en español
  return format(parsedDate, formato, { locale: es });
};

export default convertDate
